/* sb-dc-ratefix.js v2 - correct the per-square-foot rate shown for the two
   custom Step & Repeat cards in the design center. 2026-10-01.

   The live products are $1.99 (custom-step-and-repeat-banner) and $2.99
   (custom-fabric-step-repeat-banner); the catalog cards carried the wrong flat
   rate ($1.53 / $2.50 - the 8x8 special's per-sqft). Verified in the browser:
   __dcUnitPriceFor gives vinyl 8x8 $98, 10x8 $128, 10x10 $199.

   Two separate things show the rate here, so there are two parts:
   1) card.rate - drives the size panel's "$X/sq.ft" and every non-special size's
      price. Set to the correct flat rate.
   2) the product-chooser card subtitle - the app appends " . $X/sq.ft" to
      card.material using the CHEAPEST per-sqft the card can make, which is the
      8x8 special (98/64 = $1.53). That calc lives in the 341KB bundle we cannot
      edit, so we correct the rendered subtitle text to the flat rate. The
      8x8/8x10 specials still apply at those sizes - only the headline changes.

   We do NOT touch card.specials or add a rate map: card.specials already drives
   the 8x8 $98 / 8x10 $128 (fabric $160 / $200) deals (verified with
   __dcUnitPriceFor after removing the map), so none is needed.

   To undo, remove the section that loads this file
   (templates/page.design-center.json -> sb-dc-ratefix).

   Diagnostics: window.__dcRateFix()
*/
(function () {
  "use strict";

  var RATE = {
    "custom-step-and-repeat-banner": 1.99,
    "fabric-step-repeat-banners": 2.99
  };

  // chooser subtitle = card.material + " . $<cheapest>/sq.ft". Force the flat rate.
  var LABELS = [
    { pre: "Vinyl \u00b7 any size (min 4ft)", full: "Vinyl \u00b7 any size (min 4ft) \u00b7 $1.99/sq.ft" },
    { pre: "270gsm fabric \u00b7 any size (min 4ft)", full: "270gsm fabric \u00b7 any size (min 4ft) \u00b7 $2.99/sq.ft" }
  ];

  var info = { rateSet: [], labelFixes: 0 };
  window.__dcRateFix = function () { return info; };

  function appliedHandle() { var p = window.__dcProduct; return (p && p.id) || ""; }

  function findCard(cat, handle) {
    for (var i = 0; i < cat.length; i++) {
      var items = (cat[i] && cat[i].items) || [];
      for (var j = 0; j < items.length; j++) if (items[j] && items[j].handle === handle) return items[j];
    }
    return null;
  }

  function setRates() {
    var cat = window.__CAT;
    if (!cat || !cat.length) return false;
    var done = true;
    Object.keys(RATE).forEach(function (handle) {
      if (info.rateSet.indexOf(handle) >= 0) return;
      var card = findCard(cat, handle);
      if (!card) { done = false; return; }
      card.rate = RATE[handle];
      info.rateSet.push(handle);
      if (appliedHandle() === handle && window.__dcApi && window.__dcApi.setSpec) {
        try { window.__dcApi.setSpec({}, false); } catch (e) {}
      }
    });
    return done;
  }

  function fixLabels(root) {
    if (!root || !root.querySelectorAll) return;
    var els = root.querySelectorAll("*");
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length) continue;
      var t = el.textContent;
      if (!t) continue;
      for (var j = 0; j < LABELS.length; j++) {
        if (t.indexOf(LABELS[j].pre) === 0 && t !== LABELS[j].full) {
          el.textContent = LABELS[j].full;
          info.labelFixes++;
        }
      }
    }
  }

  if (!setRates()) {
    var tries = 0;
    var rt = setInterval(function () { if (setRates() || ++tries > 200) clearInterval(rt); }, 50);
  }

  function sweep() { try { fixLabels(document.body); } catch (e) {} }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", sweep);
  else sweep();
  if (window.MutationObserver) {
    var deb = null;
    new MutationObserver(function () {
      if (deb) return;
      deb = setTimeout(function () { deb = null; sweep(); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  var sweeps = 0;
  var st = setInterval(function () { sweep(); if (++sweeps > 40) clearInterval(st); }, 500);
})();
